import type { ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  activo?: boolean;
}

export function Chip({ activo, className, children, ...rest }: Props) {
  return (
    <button
      type="button"
      aria-pressed={activo}
      className={[
        'shrink-0 rounded-full px-3.5 py-1.5 text-xs font-medium transition active:scale-[0.98]',
        activo
          ? 'bg-navy text-white'
          : 'border border-borde bg-white text-texto/70 hover:border-navy/30',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}
